export { LinearGradient as default } from 'expo-linear-gradient';
